const $ = window.$;
// Displays a progressbar that can show either a determinate or indeterminate animation
export default function(id) {
	this.id = id;
	this.$outer;
	this.$determinate;
	this.$indeterminate;
	this.$indeterminateA;
	this.$indeterminateB;
	this.$indeterminateC;
	this.$indeterminateAnimators;

	// properties
	this.isIndeterminate = false;
	let  _cancelIndeterminateAnimation = false;

	this.reset = function () {
		this.strTaskGUID = '';
		this.stopIndeterminate();
		this.stopDeterminate();
	};

	// -----------------------------
	// Determinate
	// -----------------------------
	this.startDeterminate = function () {
		this.stopIndeterminate();
		this.stopDeterminate();
		this.$determinate.addClass('is-visible');
	};

	this.stopDeterminate = function () {
		this.$determinate.removeClass('is-visible');
		_resetDeterminate.call(this);
	};

	this.setDeterminate = function (amount) {
		this.$determinate.css('width', amount + '%');
	};

	function _resetDeterminate () {
		this.$determinate
			.addClass('no-animate')
			.width(0)
			.removeClass('no-animate');
	}

	// -----------------------------
	// Indeterminate
	// -----------------------------
	this.startIndeterminate = function () {
		this.stopDeterminate();
		this.$indeterminate.addClass('is-visible');
		_cancelIndeterminateAnimation = false;
		_animateIndeterminate.call(this);
	};

	this.stopIndeterminate = function () {
		this.$indeterminate.removeClass('is-visible');
		_cancelIndeterminateAnimation = true;
	};

	function _animateIndeterminate() {
		var that = this;
		if (_cancelIndeterminateAnimation) {
			_cancelIndeterminateAnimation = false;
			return;
		}
		window.requestAnimationFrame(function () {
			_indeterminateAnimationA.call(that);
			_indeterminateAnimationB.call(that);
		});
	}

	function _indeterminateAnimationA() {
		var animatorWidth = this.$animators.first().width();
		var barWidth = this.$outer.width();
		var that = this;
		$(this.$animators[0])
			.velocity({
				translateX: [barWidth * 1.7 + animatorWidth + 'px', animatorWidth * -1 + 'px'],
			}, {
				delay: 0,
				duration: 1400,
				easing: [.36, .75, .56, .14],
				complete: function () {
					// stop animations executing so they don't get too far apart from one another over many cycles
					that.$animators.each(function () {
						$(this).velocity('stop');
					});

					// recycle the animation
					_animateIndeterminate.call(that);
				}
			});

		// animate second bit at a slightly different easing to make the animation more interesting
		$(this.$animators[1])
			.velocity({
				translateX: [barWidth * 1.7 + animatorWidth + 'px', animatorWidth * -1 + 'px'],
			}, {
				delay: 0,
				duration: 1400,
				easing: [.26, .75, 1, .28],
			});
	}
	function _indeterminateAnimationB() {

		var animatorWidth = this.$animators.first().width();
		var barWidth = this.$outer.width();

		$(this.$animators[2])
			.velocity({
				translateX: [barWidth * 1.1 + animatorWidth + 'px', animatorWidth * -1 + 'px'],
			}, {
				easing: 'linear',
				delay: 800,
				duration: 600
			});
	}

	// -----------------------------
	// Initialization
	// -----------------------------
	function _cacheSelectors() {
		this.id = id;
		this.$outer = $('#' + id);
		this.$determinate = this.$outer.find('.js-progress-determinate');
		this.$indeterminate = this.$outer.find('.js-progress-indeterminate');
		this.$animators = this.$outer.find('.js-indeterminate-animator');
	}

	this.init = function () {
		_cacheSelectors.call(this);
	};
}
